import React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { NonWeightableTooltip } from '../NonWeightableTooltip'

type Props = {
  weight: number
  weightable: boolean
}
export const WeightTag: React.FC<Props> = ({ weight, weightable }) => {
  const Wrapper = weightable ? React.Fragment : NonWeightableTooltip
  return (
    <Box cursor="default">
      <Wrapper>
        <Tag icon="calculator" leftItem="icon">
          {weight} %
        </Tag>
      </Wrapper>
    </Box>
  )
}
